import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'pieceIcon',
  standalone: true,
})
export class PieceIconPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    const transformedValue = value
      .replace(/N/g, '♘')
      .replace(/B/g, '♗')
      .replace(/R/g, '♖')
      .replace(/Q/g, '♕')
      .replace(/K/g, '♔');
    return this.sanitizer.bypassSecurityTrustHtml(transformedValue);
  }
}
